import { captureExceptionWithExtras } from './sentry-lazy';

export class Logger {
  private prefix: string = '';

  constructor(namespace?: string) {
    if (namespace) {
      this.prefix = `[${namespace}] `;
    }
  }

  info(message: string, ...extra: any[]) {
    console.info(this.prefix + message, ...extra);
  }

  debug(message: string, ...extra: any[]) {
    console.debug(this.prefix + message, ...extra);
  }

  warn(message: string, ...extra: any[]) {
    console.warn(this.prefix + message, ...extra);
  }

  error(message: string, error?: any, extra?: any) {
    console.error(this.prefix + message, error, extra);

    captureExceptionWithExtras(new Error(message, { cause: error }), extra);
  }

  log(message: any, ...extra: any[]): void {
    console.log(this.prefix + message, ...extra);
  }

  /**
   * Creates a child logger which applies additional metadata to every log
   */
  getLogger(namespace: string): Logger {
    return new Logger(namespace);
  }
}

export const log = new Logger();
